import { useAppDispatch, useAppSelector } from '@/hooks';
import { openMyBetsModal } from '@/store/slices/currentBetCountSlice';

export function FloatingMyBetsButton() {
  const dispatch = useAppDispatch();
  const { totalItems, isFloatingMyBetsVisible } = useAppSelector((state) => state.currentBetCount);
  const totalItemsText = totalItems > 99 ? '99+' : totalItems;

  if (totalItems === 0 || !isFloatingMyBetsVisible) return null;

  return (
    <button
      type="button"
      onClick={() => dispatch(openMyBetsModal())}
      className="fixed bottom-[9.25rem] left-3 sm:left-1/2 sm:-translate-x-[14rem] z-50 flex size-[3.35rem] pb-2.5 justify-center items-end rounded-full bg-black/85 text-white shadow-xl"
      aria-label="Open My Bets"
    >
      <span className="relative flex size-7 items-center justify-center">
        <i className="icon-list text-[1.65rem]" />
        <span className="absolute -right-1.5 -top-1.5 flex min-h-[1.15rem] min-w-[1.15rem] items-center justify-center rounded-full bg-[#e50000] px-1 text-[0.65rem] font-bold leading-none text-white">
          {totalItemsText}
        </span>
      </span>
    </button>
  );
}
